export enum Organisations {
  NONE = "NONE",

  BELSGV = "BELSGV",
  BELFOS = "BELFOS",
  BELCHI = "BELCHI",
  BELKSA = "BELKSA",
  BELKLJ = "BELKLJ",

  NLDSCO = "NLDSCO",

  OTHER = "OTHER",
}

export const orgData = {
  [Organisations.BELSGV]: {
    country: "be",
    name: "Scouts en Gidsen Vlaanderen",
  },
  [Organisations.BELFOS]: { country: "be", name: "FOS Open Scouting" },
  [Organisations.BELCHI]: { country: "be", name: "Chirojeugd Vlaanderen" },
  [Organisations.BELKSA]: { country: "be", name: "KSA" },
  [Organisations.BELKLJ]: { country: "be", name: "KLJ" },
  [Organisations.NLDSCO]: { country: "nl", name: "Scouting Nederland" },
};
